import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth-context";
import { ThemeProvider } from "./lib/theme-context";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";

// Lazy load all heavy pages
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const ComposePage = lazy(() => import("./pages/ComposePage"));
const AccountsPage = lazy(() => import("./pages/AccountsPage"));
const SchedulesPage = lazy(() => import("./pages/SchedulesPage"));
const LogsPage = lazy(() => import("./pages/LogsPage"));
const AnalyticsPage = lazy(() => import("./pages/AnalyticsPage"));

const PageLoader = () => (
  <div className="flex items-center justify-center h-48">
    <div className="w-5 h-5 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<Layout />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/compose" element={<ComposePage />} />
                <Route path="/compose/:scheduleId" element={<ComposePage />} />
                <Route path="/accounts" element={<AccountsPage />} />
                <Route path="/schedules" element={<SchedulesPage />} />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
